/** Static PDP tab bodies (mirrors maison/client en-US `maison.tab*` strings). */

export const PDP_TAB_SHIPPING = `Free standard shipping on orders over $150. Express delivery is available for orders placed before 2pm on business days. International shipping may be available — rates and duties vary by destination.`;

export const PDP_TAB_RETURNS = `Free returns within 30 days of delivery. Items must be unworn, unwashed, and have all original tags attached. Exchanges are available online and in participating stores. Final sale items are noted at checkout.`;

export const PDP_TAB_CARE = `Follow the care label inside your garment. When in doubt, dry clean or cold wash with like colours and line dry.`;
